module.exports = __webpack_public_path__ + "static/img/PatrickMiescher.jpg";